export function CommshubSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/commshub.svg'"></ng-include>`
    }
}